import { application } from '@/controllers'

// Use the date picker on every page
import DatePickerController from '@/controllers/date_picker_controller'
application.register('date-picker', DatePickerController)

// Use the search controller on every page
import SearchController from '@/controllers/search_controller'
application.register('search', SearchController)

// Use the checkbox controller on every page
import CheckboxController from '@/controllers/checkbox_controller'
application.register('checkbox', CheckboxController)

// Use the choices controller on every page
import ChoicesController from '@/controllers/choices_controller'
application.register('choices', ChoicesController)

import AutoSubmitFormController from '@/controllers/auto_submit_form_controller'
application.register('auto-submit-form', AutoSubmitFormController)

import FocusTrapController from '@/controllers/focus_trap_controller'
application.register('focus-trap', FocusTrapController)

import SpacebarLinkController from '@/controllers/spacebar_link_controller'
application.register('spacebar-link', SpacebarLinkController)

import FormErrorsController from '@/controllers/form_errors_controller'
application.register('form-error', FormErrorsController)

import FlashAlertController from '@/controllers/flash_alert_controller'
application.register('flash-alert', FlashAlertController)

import CheckboxSelectorController from '@/controllers/checkbox_selector_controller'
application.register('checkbox-selector', CheckboxSelectorController)

import NumberFieldButtonsController from '@/controllers/number_field_buttons_controller'
application.register('number-field-buttons', NumberFieldButtonsController)

import QRCodeReaderController from '@/controllers/qr_code_reader_controller'
application.register('qr-code-reader', QRCodeReaderController)

import AiCaptionController from '@/controllers/ai_caption_controller'
application.register('ai-caption', AiCaptionController)

import LineChartController from '@/controllers/line_chart_controller'
application.register('line-chart', LineChartController)

import FileUploadController from '@/controllers/file_upload_controller'
application.register('file-upload', FileUploadController)

import FileUploadUiController from '@/controllers/file_upload_ui_controller'
application.register('file-upload-ui', FileUploadUiController)

import CookiesController from '@/controllers/cookies_controller'
application.register('cookies', CookiesController)

import StickyHeaderController from '@/controllers/sticky_header_controller'
application.register('sticky-header', StickyHeaderController)

import TooltipHoverController from '@/controllers/tooltip_hover_controller'
application.register('tooltip-hover', TooltipHoverController)

import MobileNumberValidationController from '@/controllers/mobile_number_validation_controller'
application.register(
  'mobile-number-validation',
  MobileNumberValidationController,
)

import ProductGroupController from '@/controllers/orders/product_group_controller'
application.register('product-group', ProductGroupController)

import ProductQuestionsController from '@/controllers/orders/product_questions_controller'
application.register('product-questions', ProductQuestionsController)

import CollapsibleController from '@/controllers/collapsible_controller'
application.register('collapsible', CollapsibleController)

import FileSizeValidationController from '@/controllers/file_size_validation_controller'
application.register('file-size-validation', FileSizeValidationController)

import ExpireCartController from '@/controllers/orders/expire_cart_controller'
application.register('expire-cart', ExpireCartController)

import PaginatedFormController from '@/controllers/forms/paginated_form_controller'
application.register('paginated-form', PaginatedFormController)

import ClientSideValidationController from '@/controllers/forms/client_side_validation_controller'
application.register('client-side-validation', ClientSideValidationController)

import UserSupportController from '@/controllers/user_support_controller'
application.register('user-support', UserSupportController)

console.log('Loaded application_es6.js')
